<template>
  <div class="swiper-and-login">
    <div class="swiper-box">
      <el-carousel
        trigger="click"
        height="455px"
        arrow="always"
        :autoplay="true"
        :interval="2000"
        indicator-position="none"
      >
        <el-carousel-item
          v-for="(item, index) in swiperList"
          :key="item.pictureName + index"
        >
          <img
            class="swiper-imgs"
            :src="item.pictureUrl"
            :alt="item.pictureName"
            @click="handleImg(item.pictureLink)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="info-box">
      <el-tabs v-model="activeName" class="info-tab">
        <el-tab-pane label="通知公告" name="first">
          <ModuleInfo :list="informList" @toDetail="handleInformItem" @toMore="handleInformMore" />
        </el-tab-pane>
        <el-tab-pane label="行业动态" name="second">
          <ModuleInfo :list="industryList" @toDetail="handleIndustryItem" @toMore="handleIndustryMore" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import ModuleInfo from '../modules/moduleInfo'
import * as API from '../../../api/home/index'

export default {
  name: 'HomeSection1',

  components: { ModuleInfo },
  data() {
    return {
      swiperList: [],
      activeName: 'first',
      informList: [],
      industryList: []
    }
  },
  created() {
    this.getSwiperList()
    this.getInformList()
    this.getIndustryList()
  },
  methods: {
    async getSwiperList() {
      try {
        const params = { page: 1, limit: 8 }
        const res = await API.getHomeSection1Swiper(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.swiperList = records
        }
      } catch (error) {}
    },
    // 获取通知公告
    async getInformList() {
      try {
        const params = {
          page: 1,
          limit: 6,
          classifyId: 1
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.informList = records
        }
      } catch (error) {}
    },
    // 获取行业动态
    async getIndustryList() {
      try {
        const params = {
          page: 1,
          limit: 6,
          classifyId: 2
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.industryList = records
        }
      } catch (error) {}
    },
    handleImg(url) {
      if (url) window.open(url)
    },
  // 通知公告查看更多
    handleInformMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 1 }
      })
    },
    // 通知公告查看单条
    handleInformItem(id) {
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 1, id }
      })
    },
    // 行业动态查看更多
    handleIndustryMore(query) {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 2 }
      })
    },
    handleIndustryItem(id) {
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 2, id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-and-login {
  width: 1300px;
  height: 502px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .swiper-box {
    width: 812px;
    height: 455px;
    margin-right: 20px;
    .swiper-imgs {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }

  .info-tab {
    ::v-deep .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
      .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
      }
    }
    ::v-deep .el-tabs__nav {
      float: unset;
      .el-tabs__active-bar {
        height: 4px;
        background-color: #0861D5;
      }
      .el-tabs__item {
        height: auto;
        padding-bottom: 6px;
        line-height: 28px;
        font-weight: 400;
        font-size: 20px;
        color: #2F2F2F;
        &.is-active {
          color: #2F2F2F;
          font-weight: 600;
        }
      }
    }
  }

  .info-box {
    width: 416px;
    height: 455px;
    box-sizing: border-box;
    padding: 24px;
    background: linear-gradient( 180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
    border-radius: 8px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
}
</style>
